module.exports = __webpack_public_path__ + "static/media/elizabeth.91fcee35.png";